"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$ = exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$outboundSchema = exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$inboundSchema = exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$ = exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$outboundSchema = exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$inboundSchema = void 0;
exports.getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurityToJSON = getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurityToJSON;
exports.getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurityFromJSON = getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurityFromJSON;
exports.getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequestToJSON = getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequestToJSON;
exports.getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequestFromJSON = getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$;
(function (GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$) {
    /** @deprecated use `GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$inboundSchema` instead. */
    GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$.inboundSchema = exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$inboundSchema;
    /** @deprecated use `GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$outboundSchema` instead. */
    GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$.outboundSchema = exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$outboundSchema;
})(GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$ || (exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$ = GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$ = {}));
function getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurityToJSON(getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity) {
    return JSON.stringify(exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$outboundSchema
        .parse(getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity));
}
function getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetSecurity' from JSON`);
}
/** @internal */
exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$inboundSchema = z.object({
    "filter[end_date]": z.string().optional(),
    "filter[start_date]": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_date]": "filterEndDate",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$outboundSchema = z.object({
    filterEndDate: z.string().optional(),
    filterStartDate: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndDate: "filter[end_date]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$;
(function (GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$) {
    /** @deprecated use `GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$inboundSchema` instead. */
    GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$.inboundSchema = exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$inboundSchema;
    /** @deprecated use `GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$outboundSchema` instead. */
    GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$.outboundSchema = exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$outboundSchema;
})(GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$ || (exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$ = GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$ = {}));
function getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequestToJSON(getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest) {
    return JSON.stringify(exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$outboundSchema
        .parse(getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest));
}
function getLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetLettingsNationalTotalPropertiesLetStatsLettingsNationalTotalPropertiesLetGetRequest' from JSON`);
}
//# sourceMappingURL=getlettingsnationaltotalpropertiesletstatslettingsnationaltotalpropertiesletget.js.map